<script setup lang="ts">
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/core/components/ui/tabs";
import NotificationTemplatesTab from "@/rcs/components/tabs/NotificationTemplatesTab.vue";
import NotificationSequencesTab from "@/rcs/components/tabs/NotificationSequencesTab.vue";
import NewFeatureTag from "@/core/components/tags/NewFeatureTag.vue";
</script>

<template>
  <Tabs default-value="templates">
    <div class="flex items-center justify-between gap-4 flex-wrap mb-8">
      <TabsList>
        <TabsTrigger value="templates">
          Modèles
        </TabsTrigger>
        <TabsTrigger value="sequences">
          <div class="flex items-center gap-2">
            <span class="leading-tight">Séquences de suivi</span>
            <NewFeatureTag />
          </div>
        </TabsTrigger>
      </TabsList>

      <div id="rcs-tag-select" class="ml-auto" />
    </div>

    <TabsContent value="templates">
      <NotificationTemplatesTab />
    </TabsContent>

    <TabsContent value="sequences">
      <NotificationSequencesTab />
    </TabsContent>
  </Tabs>
</template>
